import React from 'react';
import styled from 'styled-components';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import SegmentAnalytics from 'ff/common/SegmentAnalytics';

import { useCurrentTracklog } from 'ff/debrief/hooks';
import { useDebriefModal } from 'ff/debrief/modalManager';
import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';

const dTypes = {
    kmlFiltered: {
        label: 'KML (Filtered)',
        value: 'kml-filtered',
    },
    kmlFull: {
        label: 'KML (Full)',
        value: 'kml',
    },
    gpx: {
        label: 'GPX',
        value: 'gpx',
    },
    csv: {
        label: 'CSV',
        value: 'csv',
    },
};

const DownloadsModal = () => {
    const { isOpen, close } = useDebriefModal('Downloads');

    const { tracklog: tl } = useCurrentTracklog();

    const handleClose = () => {
        close();
    };

    if (!tl) return null;
    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DebriefDialogTitle onClose={handleClose}>
                Downloads
            </DebriefDialogTitle>
            <DialogContent>
                <List>
                    <DownloadOptionRow path={dTypes.kmlFiltered.value}>
                        {dTypes.kmlFiltered.label}
                    </DownloadOptionRow>
                    <DownloadOptionRow path={dTypes.kmlFull.value}>
                        {dTypes.kmlFull.label}
                    </DownloadOptionRow>
                    <DownloadOptionRow path={dTypes.gpx.value}>
                        {dTypes.gpx.label}
                    </DownloadOptionRow>
                    <DownloadOptionRow path={dTypes.csv.value}>
                        {dTypes.csv.label}
                    </DownloadOptionRow>
                </List>
            </DialogContent>
        </Dialog>
    );
};

const DownloadOptionRow = (
    props: React.PropsWithChildren<{ path: string }>
) => {
    const { close } = useDebriefModal('Downloads');
    const { tracklog } = useCurrentTracklog();
    const link = '/tracklogs/export/' + tracklog.trackUuid + '/' + props.path;

    const handleClick = () => {
        SegmentAnalytics.logEvent('Debrief, Downloaded', {
            fileType: props.path,
        });
        close();
    };

    return (
        <RowContainer>
            <Typography fontWeight="bold">{props.children}</Typography>
            <Link
                fontFamily="helvetica neue, helvetica, sans-serif"
                fontSize=".85rem"
                sx={{ textDecoration: 'none' }}
                href={link}
                onClick={handleClick}
                download
            >
                Download
            </Link>
        </RowContainer>
    );
};

const List = styled.ol`
    list-style: none;
    margin: 0;
    padding: 0;
`;

const RowContainer = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    &:not(:last-child) {
        border-bottom: 1px solid #e0e1df;
    }
`;

export default DownloadsModal;
